import { ChangeType, CollapsedSection, ProcessedDiff, ProcessedLine } from '@components/ncFileVersions/components/NCFileDiffView/types';
import { isCollapsedSection } from './utils';

export interface ExpansionSourceLines {
  oldLines: string[];
  newLines: string[];
}

export const expandCollapsedSection = (
  prev: ProcessedDiff,
  section: CollapsedSection,
  fullLines: ExpansionSourceLines,
): ProcessedDiff => {
  const newOldLines = [...prev.oldLines];
  const newNewLines = [...prev.newLines];

  const findCollapsedIndex = (arr: typeof newOldLines) =>
    arr.findIndex((item) => isCollapsedSection(item) && item.key === section.key);
  const oldIndex = findCollapsedIndex(newOldLines);
  const newIndex = findCollapsedIndex(newNewLines);

  if (oldIndex === -1 || newIndex === -1) {
    return prev;
  }

  const expandedOldLines: ProcessedLine[] = [];
  const expandedNewLines: ProcessedLine[] = [];

  // startLineOld/startLineNew are 1-based; 0 = no counterpart on this side
  // (pure addition/removal). Out-of-bounds (>length) only occurs against truncated content.
  for (let i = 0; i < section.count; i++) {
    const oldLineNum = section.startLineOld + i;
    const newLineNum = section.startLineNew + i;

    const oldContentLine = oldLineNum > 0 && oldLineNum <= fullLines.oldLines.length ? fullLines.oldLines[oldLineNum - 1] : '';
    const newContentLine = newLineNum > 0 && newLineNum <= fullLines.newLines.length ? fullLines.newLines[newLineNum - 1] : '';

    expandedOldLines.push({
      oldLineNumber: oldLineNum > 0 ? oldLineNum : null,
      newLineNumber: newLineNum > 0 ? newLineNum : null,
      content: oldContentLine,
      changeType: ChangeType.UNCHANGED,
      key: `expanded-old-${section.key}-${i}`,
    });

    expandedNewLines.push({
      oldLineNumber: oldLineNum > 0 ? oldLineNum : null,
      newLineNumber: newLineNum > 0 ? newLineNum : null,
      content: newContentLine,
      changeType: ChangeType.UNCHANGED,
      key: `expanded-new-${section.key}-${i}`,
    });
  }

  newOldLines.splice(oldIndex, 1, ...expandedOldLines);
  newNewLines.splice(newIndex, 1, ...expandedNewLines);

  return { oldLines: newOldLines, newLines: newNewLines };
};
